import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  NgbDateParserFormatter,
  NgbDatepicker,
  NgbModal
} from "@ng-bootstrap/ng-bootstrap";
import { DateActions } from "../../models/Demographics";
// import { NgbDateFRParserFormatter } from "../../services/datePicker/NgbDateFRParserFormatter";
import * as moment from "moment";

@Component({
  selector: "app-reusable-date-navigator",
  templateUrl: "./reusable-date-navigator.component.html",
  styleUrls: ["./reusable-date-navigator.component.css"]
  // providers: [
  //   { provide: NgbDateParserFormatter, useClass: NgbDateFRParserFormatter }
  // ]
})
export class ReusableDateNavigatorComponent implements OnInit {
  @Input() currentDate: any;
  @Input() isNewAppointmentComponent;
  @Input() isThreeDaysSelected;
  @Output() nextDateClicked = new EventEmitter<boolean>();
  @Output() prevDateClicked = new EventEmitter<boolean>();
  @Output() todayClicked = new EventEmitter<boolean>();
  @Output() threeDaysClicked = new EventEmitter<boolean>();
  @Output() calendarDateSelected = new EventEmitter<string>();

  constructor() {}

  loadThreeDays() {
    this.threeDaysClicked.emit(true);
  }
  getThirdDay(date: string) {
    // TODO: check for multiple calls
    let m = moment(DateActions.getDateJSONToStringWithMonthDiff(date));
    m.add("days", 2);
    let newString = {
      year: m.year(),
      month: m.month() + 1,
      day: m.date()
    };
    return newString;
  }
  loadTodayDate() {
    this.todayClicked.emit(true);
  }
  loadPreviousDate() {
    this.prevDateClicked.emit(true);
  }
  loadNextDate() {
    this.nextDateClicked.emit(true);
  }
  hiddenDatePickerChanged() {
    this.currentDate["month"] = this.currentDate["month"] - 1;
    // emit the date picker date here
    this.calendarDateSelected.emit(DateActions.getDateJSONToString(this.currentDate))
  }
  ngOnInit() {}
}
